<div class="myre-header flex">
  @if (!_smallSearchExpanded()) {
    <div class="flex left">
      @if (_menuService._displayableMenu()) {
        <i
          tabindex="0"
          role="button"
          aria-pressed="false"
          class="material-symbols-outlined"
          [class.menu--opened]="_menuOpened"
          [class.menu--closed]="!_menuOpened"
          (click)="_toggleMenu()"
        >
          dock_to_right
        </i>

        <myre-dropdown
          [list]="_dropdownItems()"
          [ngModel]="this._headerService.selectedDropdownItem()"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="_selectedItem($event)"
        />
      }
    </div>
  }

  @if (!_isSmallDisplay()) {
    <div class="center">
      @if (_menuService._displayableMenu()) {
        <i
          class="myre-icon-home"
          role="button"
          tabindex="0"
          (click)="_onHomeClick()"
        ></i>

        @if (_headerService.displaySearchBar()) {
          <myre-nav-search
            class="flex"
            shortWidth="272px"
            longWidth="272px"
            [template]="item"
            [stretch]="false"
            [items]="searchResults()"
            (onInput)="searchUserInput.emit($event)"
            (onSelect)="searchItemClicked.emit($event)"
          />
        }
      }
    </div>
  }

  <div [class.flex-grow]="_isSmallDisplay()" class="flex right">
    @if (_isSmallDisplay()) {
      <myre-nav-search
        shortWidth="0px"
        longWidth="100%"
        [startWithButtonView]="true"
        [adaptWidth]="false"
        [template]="item"
        [items]="searchResults()"
        (onInput)="searchUserInput.emit($event)"
        (onSelect)="searchItemClicked.emit($event)"
        (onFocus)="_smallSearchOpened.set(true)"
        (onBlur)="_smallSearchOpened.set(false)"
      />
    }

    @if (_isSmallDisplay() && !_smallSearchExpanded()) {
      @if (_headerService.avatar(); as avatar) {
        <myre-actions-dropdown
          [dropdownItems]="_smallMenuDropdownItems()"
          [allowFullHeight]="true"
        >
          <avatar
            [size]="32"
            [name]="avatar.loggedUserName"
            [email]="avatar.loggedUserEmail"
            [withBorder]="true"
            [imageSrc]="avatar.imgSource"
          />
        </myre-actions-dropdown>
      } @else {
        <myre-actions-dropdown
          [dropdownItems]="_smallMenuDropdownItems()"
          [allowFullHeight]="true"
          icon="myre-icon-menu_hamburger"
        />
      }
    }

    @if (!_isSmallDisplay()) {
      <myre-actions-dropdown
        icon="myre-icon-help"
        [dropdownItems]="_helpDropdownItems"
      />
    }

    @if (_headerService.feed() && !_smallSearchExpanded()) {
      <myre-nav-icon-btn
        icon="myre-icon-alert"
        [numberOfNotifications]="_headerService.feed().notifications"
        (onClick)="_headerService.feed().open()"
      />
    }

    @if (!_isSmallDisplay()) {
      @if (_headerService.settings()?.length) {
        <myre-actions-dropdown
          icon="myre-icon-settings"
          [dropdownItems]="_headerService.settings()"
          [allowFullHeight]="true"
        />
      }

      @if (_headerService.avatar(); as avatar) {
        <myre-actions-dropdown [dropdownItems]="avatar.dropdownItems">
          <avatar
            [size]="32"
            [name]="avatar.loggedUserName"
            [email]="avatar.loggedUserEmail"
            [withBorder]="true"
            [imageSrc]="avatar.imgSource"
          />
        </myre-actions-dropdown>
      }
    }

    @if (_chatService.showChat() && !_smallSearchExpanded()) {
      <i
        id="chat-launcher"
        tabindex="0"
        role="button"
        aria-pressed="false"
        class="material-symbols-outlined"
        [class.menu--opened]="_chatOpened"
        [class.menu--closed]="!_chatOpened"
        (click)="_toggleChat()"
      >
        dock_to_right
      </i>
    }
  </div>
</div>

<ng-template #item let-item let-hovered="hovered" let-select="select">
  <div
    class="search-item-container"
    [class.hover]="hovered"
    (click)="select(item)"
  >
    <div class="first-line">
      <div ellipsis>
        {{ item.label }}
      </div>

      <myre-tag [type]="TagType.Tertiary">
        {{ item.value?.type }}
      </myre-tag>
    </div>

    <div class="second-line">
      {{ item.value?.breadcrumb }}
    </div>
  </div>
</ng-template>
